export const defaultMessageByType = (type, job) => {
  switch (type) {
    case "hired":
      return `You are Hired! for ` + " " + job;
    case "rejected":
      return `Your application Rejected! for ` + " " + job;
    case "inTouch":
      return `You are in touch! for ` + " " + job;
  }
};

export const AcceptReject = (name, type, job) => {
  switch (type) {
    case "accepted":
      return `${name} accepted ` + "-" + job;
    case "rejected":
      return `${name} rejected ` + "-" + job;
  }
};
